import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { General } from 'src/app/core/models/general';
import ApiRoute from '../api-route';

@Injectable({
  	providedIn: 'root'
})
export class NotifyService {

	public headers 
  
	constructor(
		private http: HttpClient
	) { 
		this.headers = new HttpHeaders().set('Content-Type', 'application/json')
	}

	/**
	 * 建立紀錄
	 */
	public create_records(param: any): Observable<General.APIResult<any>> {
		const url = ApiRoute.notify.queue;
		return this.http.post<any>(url, param);
	}
}